const apiConstants = {
  REQUEST_AUTH: '/auth/student-login',
  REQUEST_CLEVER_AUTH: '/auth/clever-login',
  REQUEST_CLASSLINK_AUTH: '/auth/classlink-login',
  Student: '/student',
  TestTime: '/admin/test-time/assessment'
}

export default apiConstants
